import { LocationItem } from '../Card';
import React from 'react';

import { StoryItemsFragment, BasicItemsFragment } from '../../generated/graphql';
import { ItemProps } from './common';
import { storyItemRoute, basicItemRoute } from '../../helpers/routes';
import { resizeImageW } from '../../helpers/mediaApiUrls';
import { PageItemLink } from '../PageItemLink';
import snakeCase from 'lodash/snakeCase';

const Basic: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  let pageItem: StoryItemsFragment | BasicItemsFragment = item as BasicItemsFragment;
  let route = basicItemRoute(page.id, pageItem.id, preview);
  let header = 'Page Item';

  if (item.type === 'StoryItem') {
    pageItem = item as StoryItemsFragment;
    route = storyItemRoute(page.id, pageItem.id, preview);
    header = 'Story';
  }
  const photoPath = resizeImageW(pageItem.photo?.mediaUrl, 145);

  return (
    <PageItemLink
      to={route}
      page={page}
      pageItem={item}
      data-testid={`${snakeCase(item.type).replace('_', '-')}-${pageItem.id}`}
    >
      <LocationItem
        header={header}
        name={pageItem.title}
        photoPath={photoPath}
        description={pageItem.description}
        className={className}
        {...dragProps}
      />
    </PageItemLink>
  );
};

export default Basic;
